import easterTakeoverConfig from 'takeovers/easterTakeover/easterTakeoverConfig'
import lunarNewYearTakeoverConfig from 'takeovers/lunarNewYearTakeover/lunarNewYearTakeoverConfig'
import luxPlusMonthTakeoverConfig from 'takeovers/luxPlusMonthTakeover/luxPlusMonthTakeoverConfig'
import marchTravelFrenzyTakeoverConfig from 'takeovers/marchTravelFrenzyTakeover/marchTravelFrenzyTakeoverConfig'
import neverEndingSummerTakeoverConfig from 'takeovers/neverEndingSummerTakeover/neverEndingSummerTakeoverConfig'
import societyTriplePointsTakeoverConfig from 'takeovers/societyTriplePointsTakeover/societyTriplePointsTakeoverConfig'
import tourBestAsiaPromoTakeoverConfig from 'takeovers/tourBestAsiaPromoTakeover/tourBestAsiaPromoTakeoverConfig'
import valentineTakeoverConfig from 'takeovers/valentineTakeover/valentineTakeoverConfig'
import maldivesCharterTakeoverConfig from 'takeovers/maldivesCharterTakeover/maldivesCharterTakeoverConfig'

import { TakeoverId } from '../client/lib/lab/dynamicPayload'
import societeDoublePointsTakeoverConfig from './societeDoublePointsTakeover/societeDoublePointsTakeoverConfig'

export { TakeoverId }

export const takeovers: Record<TakeoverId, App.SiteTakeoverConfig | App.SiteTakeoverConfigV2> = {
  [TakeoverId.LUNAR_NEW_YEAR_TAKEOVER]: lunarNewYearTakeoverConfig,
  [TakeoverId.VALENTINE_TAKEOVER]: valentineTakeoverConfig,
  [TakeoverId.MARCH_TRAVEL_FRENZY_TAKEOVER]: marchTravelFrenzyTakeoverConfig,
  [TakeoverId.TOUR_BEST_ASIA_PROMO_TAKEOVER]: tourBestAsiaPromoTakeoverConfig,
  [TakeoverId.EASTER_TAKEOVER]: easterTakeoverConfig,
  [TakeoverId.SOCIETY_TRIPLE_POINTS_TAKEOVER]: societyTriplePointsTakeoverConfig,
  [TakeoverId.NEVER_ENDING_SUMMER_TAKEOVER]: neverEndingSummerTakeoverConfig,
  [TakeoverId.LUX_PLUS_MONTH_TAKEOVER]: luxPlusMonthTakeoverConfig,
  [TakeoverId.MALDIVES_CHARTER_TAKEOVER]: maldivesCharterTakeoverConfig,
  [TakeoverId.DOUBlE_STATUS_CREDITS_TAKEOVER]: societeDoublePointsTakeoverConfig,
} as const
